import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import type {
  ConnectInstallationRequest,
  ConnectInstallationResponse,
} from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

import { getGitHubAppConnectCandidatesQueryKey } from './useGitHubAppConnectCandidates';
import { getGitHubAppInstallationsQueryKey } from './useGitHubAppInstallations';

const connectGitHubAppInstallation = async (app: VcsApp, gitHubInstallationId: string) => {
  const response = await post<ConnectInstallationRequest, ConnectInstallationResponse>(
    `/api/vcs/github-apps/${app}/connect`,
    { gitHubInstallationId },
  );
  if (!response.data) {
    throw new Error('Empty response from connect');
  }
  return response.data;
};

/**
 * Connects one of the candidate installations to the org, then refreshes the account list (the new
 * account appears in the menu) and the candidates (it now reads as connected).
 */
export function useConnectGitHubAppInstallation(app: VcsApp) {
  return useToastedMutation({
    mutationFn: (gitHubInstallationId: string) => connectGitHubAppInstallation(app, gitHubInstallationId),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: getGitHubAppInstallationsQueryKey(app) }),
        queryClient.invalidateQueries({ queryKey: getGitHubAppConnectCandidatesQueryKey(app) }),
      ]);
    },
    successToastMessage: ({ accountName }) => `Connected ${accountName}`,
    errorToastMessage: 'Failed to connect the installation',
  });
}
